module.exports = __webpack_public_path__ + "fonts/dm-sans-v10-latin-500.82c42c7.woff2";